export interface IBANFFClassification {
    id: number,
    biopsyId: number,
    tubulitis: number,
    intimalArteritis: number,
    c4d: number,
    interstitialFibrosis: number,
    tubularAtrophy: number,
    vascularFibrousIntimalThickening: number,
    mesangialMatrixExpansion: number,
    arterioloarHyalinosis: number,
    hyalineArterioloarThickening: number,
    totalInflammation: number,
    inflammationInAreaOfIfta: number,
    interstitialInflammation: number,
    glomerulitis: number,
    peritubularCapillaritis: number,
    gbmDoubleContours: number,
    tifta: number,
    pvl: number
}